import { selfAxios } from "@oppein/op-utils";
/**
 * 订单价费预测信息导出(pc)
 * @param {*} data
 * @returns
 */
export async function getSpecialBusinessListByPlatformName(params) {
  const { data } = await selfAxios.post(
    "/designapi/design/special/getSpecialBusinessListAll",
    params,
  );
  return data;
}



// WEBPACK FOOTER //
// ./src/api/designapi/design/special/getSpecialBusinessListByPlatformName/post.js